import { render, staticRenderFns } from "./labelGroupPreview.vue?vue&type=template&id=dbdc3c46&scoped=true"
import script from "./labelGroupPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./labelGroupPreview.vue?vue&type=script&setup=true&lang=js"
import style0 from "./labelGroupPreview.vue?vue&type=style&index=0&id=dbdc3c46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdc3c46",
  null
  
)

export default component.exports